import { NavLink } from "react-router-dom";
import styled from "styled-components";
import SectionWrapper from "../../components/SectionWrapper";

export const MainSection = styled(SectionWrapper)`
  padding: 20px 0;
  @media (min-width: 768px) {
    padding: 50px 0;
  }
`;

export const NavSection = styled(SectionWrapper)`
  padding: 50px 0;
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  gap: 40px;
  & > div:first-child {
    flex-grow: 1;
  }
  & > div:last-child {
    width: 350px;
  }
`;

export const Content = styled.div`
  width: 100%;
`;

export const Heading = styled.h1`
  text-transform: capitalize;
`;

export const BreadCrumbs = styled.div`
  width: 100%;
`;

export const StyledNav = styled(NavLink)`
  text-transform: capitalize;
  font-size: 10px;
  line-height: 13px;
  /* padding: 0 5px; */
  &.current {
    color: #fb2e86;
    text-decoration: underline;
  }

  &::after {
    content: ".";
    width: 5px;
    height: 1px;
    display: inline-block;
    margin: 0 2px;
  }
`;

export const Section = styled.main`
  width: 100%;
`;
